//* 组件属性
import type { ModuleProps } from "../index";

export const useComposable = (define: ModuleProps) => {
    //* 插件
    const i18n = useI18n();
    const route = useRoute();

    const refs = {
        gene: ref<string>(""),
    };

    //* 事件列表
    const methods = {
        //* 路由切换函数
        change: (data: any) => {
            const name = route.name?.toString() || "";
            if (name) {
                //* 路由更新
                routerPush({ name: name, params: { id: data.id }, query: { mode: route.query.mode } });
            }
        },
    };

    //* 计算属性
    const computeds = {
        name: computed(() => {
            if (route.meta.route == "BioVariantResult") return i18n.t("XXXMutation", { name: define.data.name });
            else {
                return i18n.t("XXXSequence", { name: define.data.name });
            }
        }),

        selector: computed(() => {
            if (route.meta.route == "BioVariantResult") return ["Human"];
            else {
                return undefined;
            }
        }),
    };

    return { refs, methods, computeds };
};
